import React from 'react';

import { Button, Form, Modal, Schema } from 'rsuite';
import { alertError, validator } from '../../../helpers';
import { alert } from '../../../helpers/rsuite/Alerts';
import { CVUField, Field } from '../../../helpers/rsuite/Form';
import { cuotitasStoreService } from '../../../services';
//
// Styles
//
// 'lg' | 'md' | 'sm' | 'xs'
const size = {
    lg: 'lg', // large
    md: 'md', // medium
    sm: 'sm', // small
    xs: 'xs' // extra small
};
const body0 = {
    width: '540px',
    padding: '0 4px'
};
const defaultFormPassword = {
    cbucvu: '',
    account: '',
    cuitcuil: ''
};
// eslint-disable-next-line no-useless-escape
const invalidSpecialCharacters = /[`!@#$%^&*()_+\=\[\]{};':"\\|,<>\/?~ñÑ]/;

//
// Validation form
//
const required = 'Este campo es requerido.';
const { StringType } = Schema.Types;
const model = Schema.Model({
    cbucvu: StringType().isRequired(required)
        .addRule((value, data) => {
            const cvuValue = String(value);
            if (!validator.isCVU(cvuValue) && !validator.isCBU(cvuValue)) {
                // El “Alias CBU” debe tener una longitud de entre 6 y 20 caracteres alfanuméricos.
                if (cvuValue.length < 6 || cvuValue.length > 20) {
                    // Isn't an Alias
                    return false;
                }
                // has invalid special characters
                if (invalidSpecialCharacters.test(cvuValue)) return false;
            }

            return true;
        }, 'Por favor, ingrese un CBU, CVU o un Alias valido'),
    cuitcuil: StringType().isRequired(required)
        .addRule((value, data) => {
            if (!validator.isCuit(String(value))) {
                return false;
            }

            return true;
        }, 'Por favor, ingrese un CUIT valido (11 dígitos)')
});

export default function ValidateCVU ({ show, onHide, cuit }) {
    const formRef = React.useRef();
    //
    // States
    //
    const [isLoading, setIsLoading] = React.useState(false);
    // eslint-disable-next-line no-unused-vars
    const [formErrorAccount, setFormErrorAccount] = React.useState({});
    const [formAccount, setFormAccount] = React.useState(defaultFormPassword);

    //
    // Funcions
    //

    /**
     * Validate CVU/CBU or Alias
     */
    const validateCVU = () => {
        if (!formRef.current.check()) {
            console.error('Form Error');
            return;
        }
        setFormAccount((old) => ({ ...old, account: {} }));
        setIsLoading(true);
        const data = {
            cuit: cuit || formAccount.cuitcuil // remove formAccount.cuitcuil when it is integrated
        };

        return cuotitasStoreService
            .getAccountByCVU(formAccount.cbucvu, data)
            .then(res => setFormAccount((old) => ({ ...old, account: res })))
            .catch(e => {
                console.error(e);
                const dataError = e?.response?.data;
                return catchError(dataError);
            })
            .finally(() => setIsLoading(false));
    };

    const catchError = (dataError) => {
        if (dataError?.error === 'Not Found CVU') {
            return alert('warning', `${dataError?.extra?.message}.`, 7000);
        }
        if (dataError?.error.includes('didn\'t match')) {
            return alert('warning', 'Debe ser una cuenta en pesos del mismo titular que la persona que solicita el préstamo.', 7000);
        }
        if (dataError?.error.includes('is not an account in Argentine Pesos')) {
            return alert('warning', 'Debe ser una cuenta en pesos.', 7000);
        }
        if (dataError?.extra?.message) {
            return alert('warning', `${dataError?.extra?.message}.`, 7000);
        }
        return alertError('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 7000);
    };

    return (
        <Modal
            open={show}
            onClose={onHide}
            backdrop={'static'}
            className={`${show ? 'show in' : ''}`}
            aria-labelledby='reset-password-seller-modal'
            size={size.sm}
            keyboard={false}
        >
            <Modal.Header closeButton >
                <Modal.Title id='reset-password-seller-modal'>
                    <div className='d-flex justify-content-around'>
                        <h3>Cuenta para la acreditación del préstamo</h3>
                    </div>
                </Modal.Title>
            </Modal.Header >
            <Modal.Body className='mb-5 h-100 py-1' style={{ height: '540px' }}>
                {!isLoading && (
                    <div className='row m-0' style={body0}>
                        <Form
                            fluid
                            ref={formRef}
                            formValue={formAccount}
                            onChange={setFormAccount}
                            onCheck={setFormErrorAccount}
                            model={model}
                        >
                            <div className="container">
                                <CVUField classNameGroup='mb-0' classNameLabel='font-weight-bold' name="cbucvu" label="Ingreso de CBU/CVU o Alias" />
                                <Field classNameGroup='mb-3' classNameLabel='font-weight-bold' label="Ingreso de cuit (este campo no va a existir cuando esté integrado en el flujo)" name="cuitcuil" />
                            </div>
                        </Form>
                        <div>
                            {formAccount?.account && Object.entries(formAccount?.account).map((e, index) => {
                                if (['currency', 'bank'].includes(e[0])) {
                                    return <div key={index} className='col-md-10'>{[e[0], e[1].description].join(': ')}</div>;
                                }
                                return <div key={index} className='col-md-10'>{e.join(':')}</div>;
                            })}
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className='mt-4'>
                <div>
                    <Button disabled={isLoading} onClick={onHide} >Cancelar</Button>
                    <Button appearance='primary' loading={isLoading} disabled={isLoading} onClick={validateCVU} >Validar</Button>
                </div>
            </Modal.Footer>

        </Modal>
    );
};
